import type {FC} from 'react';
import type {GetMyCalendarType} from '../../../../core/entities/calendar/schema';
import {cn} from '../../../../lib/classname';
import {dayOfTheWeek, getDate, getTimeString} from './utils/dateFormatters';

const DATE_TYPE_DEADLINE = 2;

type Props = {
  calendarSchedule: GetMyCalendarType['Schedules'][0];
  isFirst: boolean;
};

export const CalendarScheduleItem: FC<Props> = ({
  calendarSchedule,
  isFirst,
}) => {
  const borderColorClass =
    calendarSchedule.dataType === DATE_TYPE_DEADLINE
      ? 'border-sns-google-plus-red'
      : 'border-sns-line-green';

  return (
    <li
      className={cn(
        'mb-2 pl-4 relative',
        isFirst ? 'pb-8' : 'border-t border-line pt-8',
      )}
    >
      <a href={calendarSchedule.url}>
        <div className="grid gap-4 grid-cols-3">
          <div
            className={`grid grid-rows-2 gap-16 w-[90px] h-[30px] border-r-[3px] text-black-1 leading-none ${borderColorClass} float-left`}
          >
            <div className="text-[20px]">
              {getDate(calendarSchedule.start)}
              <span className="text-[11px] pl-12 text-black-2">
                {`( ${dayOfTheWeek(calendarSchedule.start)} )`}
              </span>
            </div>
            <div className="text-[11px] pt-[2px]">
              {calendarSchedule.isAllDay
                ? ''
                : getTimeString(calendarSchedule.start)}
            </div>
          </div>
          <div className="col-span-2 grid grid-rows-2 gap-0">
            <div className="pl-8 text-[13px] mb-1 font-bold text-black-1 truncate">
              {calendarSchedule.companyText}
            </div>
            <div className="pl-8 text-[14px] text-black-2">
              {calendarSchedule.typeText + calendarSchedule.dataTypeText}
            </div>
          </div>
        </div>
      </a>
    </li>
  );
};
